export class CreateWalletDTO{
  name: string;
  document: string;
  street: string;
  streetNumber: string;
  neighborhood: string;
  zipcode: string;
}
